import { useTheme } from "@mui/material";
import { LineChart, type LineChartProps } from "@mui/x-charts";
import type { FC } from "react";

type Props = LineChartProps & {
	hideFirstSeriesLine?: boolean;
};

export const MyPlannLineChart: FC<Props> = ({
	hideFirstSeriesLine,
	...lineChartProps
}) => {
	const theme = useTheme();

	return (
		<LineChart
			{...lineChartProps}
			sx={{
				"& .MuiChartsGrid-line": {
					stroke: theme.palette.grey[100],
					strokeDasharray: "3 3",
				},
				"& .MuiChartsAxisHighlight-root": {
					strokeDasharray: "none",
					stroke: theme.palette.grey[500],
					strokeWidth: 0.5,
				},
				"& .MuiChartsAxis-line": {
					stroke: `${theme.palette.grey[100]} !important`,
					strokeWidth: 1,
					strokeDasharray: "3 3",
				},
				"& .MuiLineElement-series-auto-generated-id-0": {
					strokeWidth: hideFirstSeriesLine ? 0 : 2,
				},
				"& .MuiLineElement-series-auto-generated-id-1": {
					strokeWidth: 2,
				},
				"& .MuiAreaElement-series-auto-generated-id-1": {
					opacity: 0.12,
				},
			}}
		/>
	);
};
